import jwt from "jwt-decode";
import Cookies from "js-cookie";
import moment from "jalali-moment";
import {
  getShebaInfo,
  isShebaValid,
  numberToWords,
} from "@persian-tools/persian-tools";
import { isNumber } from "lodash";

import {
  adminPermissions,
  agentPermissions,
  receptionPermissions,
  shopPermissions,
  userRoleItems,
} from "./enum";
import {
  SlickArrowLeft,
  SlickArrowRight,
} from "../helpers/SlickArrows/SlickArrows";

//* Start Cookie
export const getCookies = (name) => {
  return Cookies.get(name);
};

export const removeCookies = (name, path = "/") => {
  return Cookies.remove(name, { path });
};

export const setCookies = (name, value, path = "/") => {
  return Cookies.set(name, value, { path, expires: 7 });
};
//* End Cookie

//* Start Number Utils
export const numberSeparate = (number) => {
  if (isNumber(number) || number)
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const convertNumberToWords = (number) => {
  return numberToWords(Math.floor(number));
};
//* End Number Utils

//* Start JWT Utils
export const decodeJWT = (token) => {
  if (!token) return;
  return jwt(token);
};
//* End JWT Utils

//* Start Date Utils
export const convertDate = (date, format = "YYYY/MM/DD", locale = "fa") => {
  if (!date || date === "0001-01-01T00:00:00") return "-";
  return moment(date).locale(locale).format(format);
};
export const calculateDuration = (date1, date2, locale = "fa") => {
  if (!date1 || date1 === "0001-01-01T00:00:00" || !date2 || date2 === "0001-01-01T00:00:00") return "-";
  const copyDate1 = new moment(date1)
  const copyDate2 = new moment(date2)
  const duration = moment.duration(copyDate2.diff(copyDate1)).locale(locale);
  let returnValue = ''
  if (duration._data.hours > 0) { returnValue += duration._data.hours + " ساعت" }
  if (duration._data.minutes > 0) { returnValue += " و " + duration._data.minutes + " دقیقه" }
  return returnValue;

};
export const calculateTotalHours = (
  startDate,
  endDate,
  hoursPerDay,
  callback
) => {
  if (!startDate || !endDate || !hoursPerDay) return;

  const dayPerMillisecond = 86_400_000;
  const day = (endDate - startDate) / dayPerMillisecond + 1;
  if (day <= 0) return;

  if (callback) callback(day * hoursPerDay);
};
//* End Date Utils

//* Start Convert Number Utils
let persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
let arabicNumbers = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];
let englishNumbers = [
  /0/g,
  /1/g,
  /2/g,
  /3/g,
  /4/g,
  /5/g,
  /6/g,
  /7/g,
  /8/g,
  /9/g,
];

export const convertToArabicNumber = (str) => {
  if (typeof str === "string") {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
};

export const convertToEnglishNumber = (str) => {
  if (typeof str === "string") {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(englishNumbers[i], i);
    }
  }
  return str;
};

//* End Convert Number Utils

//* Start Convert String Utils
export const convertStringToBoolean = (value) => !!+value;
//* End Convert String Utils

//* Start Date Utils
export const getLocaleDate = (
  options = { year: "numeric", month: "2-digit", day: "2-digit" },
  locales = "fa-IR"
) => {
  return convertToEnglishNumber(
    new Date().toLocaleDateString(locales, options)
  );
};
export const getISOStringDate = (date) =>
  moment(new Date(date).toLocaleDateString(), "M/D/YYYY").format("YYYY-MM-DD");
//* End Date Utils

//* Start Role
export const convertRoleToText = (role) => {
  let result = null;
  switch (role) {
    case userRoleItems[0]:
      result = "ادمین";
      break;
    case userRoleItems[1]:
      result = "نماینده";
      break;
    case userRoleItems[2]:
      result = "مشتری";
      break;
    case userRoleItems[3]:
      result = "پذیرنده";
      break;
    case userRoleItems[4]:
      result = "فروشگاه";
      break;

    default:
      break;
  }
  return result;
};
export const convertRoleToPath = (role) => {
  let result = "";
  switch (role) {
    case userRoleItems[0]:
      result = "admin";
      break;
    case userRoleItems[1]:
      result = "agent";
      break;
    case userRoleItems[2]:
      result = "customer";
      break;
    case userRoleItems[3]:
      result = "reception";
      break;
    case userRoleItems[4]:
      result = "shop";
      break;

    default:
      break;
  }
  return result;
};
//* End Role

//* Start File
export const validateFile = (file) => {
  if (!file) return;

  const maxSize = 3;
  const allowedExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".docx",
    ".xlsx",
    ".csv",
    ".pdf",
    ".mp4",
    ".avi",
  ];
  const fileExtension = file.name.split(".").pop();
  if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`))
    return "پسوند فایل مورد نظر مجاز نمی باشد";
  if (file.size > maxSize * 1024 * 1024)
    return `حجم فایل نمی تواند بیشتر از ${maxSize} مگابایت باشد`;
};
//* End File

//* Start Permission
export const convertPermission = (permissions, role) => {
  const access = [...permissions];
  const result = {};

  const rolePermissions = {
    [userRoleItems[0]]: adminPermissions,
    [userRoleItems[1]]: agentPermissions,
    [userRoleItems[2]]: agentPermissions,
    [userRoleItems[3]]: receptionPermissions,
    [userRoleItems[4]]: shopPermissions,
  }[role];

  for (let key = 0; key < access.length; key++) {
    const val = access[key];
    result[Object.keys(rolePermissions)[key]] = convertStringToBoolean(val);
  }
  return result;
};
//* End Permission

//* Start Map
export const initialViewState = {
  longitude: 51.3847,
  latitude: 35.7119,
  zoom: 16,
};
//* End Map

//* Start Sheba
export const shebaInfo = (sheba) => {
  if (!sheba) return;
  const shebaNumber = `IR${sheba}`;
  let result = "";

  if (isShebaValid(shebaNumber))
    result = getShebaInfo(shebaNumber)?.persianName || "";

  return result;
};
//* End Sheba

//* Start File
export const convertDataURLtoFile = (dataURL, filename) => {
  var arr = dataURL.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};
//* End File

//* Start Filter
export const addAllItemToFilters = (items, label = "همه") => [
  {
    label,
    value: "",
  },
  ...items,
];
//* End Filter

//* Start Count Down
export const secondsCountDown = (elementId, countdownTime, callBack) => {
  let countdown = setInterval(() => {
    let element = document.getElementById(elementId);

    countdownTime--;

    if (element) element.innerHTML = countdownTime;
    else clearInterval(countdown);

    if (countdownTime <= 0) {
      clearInterval(countdown);
      if (callBack) {
        callBack();
      }
    }
  }, 1000);
};
//* End Count Down

//* Start Slider Options
export const productSliderOptions = {
  className: "slider-init center",
  centerMode: true,
  infinite: true,
  slidesToShow: 10,
  slidesToScroll: 1,
  slide: null,
  rtl: true,
  responsive: [
    { breakpoint: 1539, settings: { slidesToShow: 10 } },
    { breakpoint: 768, settings: { slidesToShow: 5 } },
    { breakpoint: 420, settings: { slidesToShow: 4 } },
  ],
  arrows: false,
  swipeToSlide: true,
  focusOnSelect: true,
};

export const productSliderOptions2 = {
  centerMode: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  rtl: true,
  responsive: [
    { breakpoint: 2560, settings: { slidesToShow: 2 } },
    { breakpoint: 1024, settings: { slidesToShow: 1, infinite: false } },
    { breakpoint: 768, settings: { slidesToShow: 1, dots: true, centerMode: false } },
  ],
  arrows: false,
  swipeToSlide: false,
  focusOnSelect: true,
};
//* End Slider Options

//* Start Wallet
export const sumWallets = (wallet) =>
  wallet && Object.values(wallet).reduce((prevValue, a) => prevValue + a, 0);
//* End Wallet

//* Start Notification Sound
export const playNotificationSound = async () => {
  let soundName = "/assets/sound/notification.mp3";

  const audio = new Audio(soundName);

  try {
    await audio.play();
  } catch (error) {
    // error
  }
};
//* End Notification Sound
